export default {
  panel: {
    title: "Ta caméra n'est pas accessible",
    description: "Pour continuer, autorise l'accès à ta caméra.",
    button: "Autoriser l'accès",
  },
};
